<template>
  <div class="register">
    <!-- <guide/> -->
    <nav-bar :title="lang.f_title" showType="text" class="nav-bars"></nav-bar>
    <nav-pc></nav-pc>
    <section>
      <div class="reg-wap" v-if="type == 1">
        <van-cell-group v-if="type == 1">
          <!-- 邮箱 -->
          <van-field type="email" v-model="reg.email" required :label="lang.email" :placeholder="lang.enter" size="large" />
          <!-- 手提电话 -->
          <van-field v-model="reg.phone" type="text" maxlength="8" required :label="lang.phone" :placeholder="lang.enter" size="large" @input="checkInt('phone', 1)" />
          <div class="forget-verify-code">
            <verify @setVerifyCode="setVerifyCode" ref="verify" />
          </div>
        </van-cell-group>
        <!-- <van-cell-group>
         <verify  @setVerifyCode="setVerifyCode" /> <label class="lab-error error-verifyCode"></label>
        </van-cell-group> -->
      </div>

      <div class="reg-wap" v-if="type == 2">
        <van-cell-group>
          <!-- 密码 -->
          <van-field type="password" v-model="reg.password" required :label="lang.password" :placeholder="lang.enter" size="large" />
          <!-- 确认密码 -->
          <van-field v-model="reg.rePassword" type="password" maxlength="20" required :label="lang.rePassword" :placeholder="lang.enter" size="large" />
        </van-cell-group>
      </div>

      <div class="reg-pc">
        <div class="flow-pc">
          <span class="reg-pc-title">{{ lang.f_title }}</span>
          <div v-html="lang.f_tip"></div>
        </div>

        <ul class="reg-pc-list">
          <!-- type=1 忘记密码验证之前 -->
          <li v-if="type == 1">
            <!-- 邮箱 -->
            <span class="reg-title"> {{ lang.email }}<label class="reg-required">* </label>:</span> <input type="email" :placeholder="lang.enter" v-model="reg.email" />
            <label class="lab-error error-email"></label>
          </li>
          <li v-if="type == 1">
            <!-- 手提電話 -->
            <span class="reg-title">{{ lang.phone }}<label class="reg-required">* </label>:</span>
            <input @input="checkInt('phone', 1)" v-model="reg.phone" type="text" maxlength="8" :placeholder="lang.enter" />
            <label class="lab-error error-phone"></label>
          </li>
          <!-- type=2，验证成功 重置密码 -->
          <li v-if="type == 2">
            <!-- 密碼 -->
            <span class="reg-title"> {{ lang.password }}:</span> <input type="password" :placeholder="lang.enter" maxlength="20" v-model="reg.password" />
            <label class="lab-error error-password"></label>
          </li>
          <li v-if="type == 2">
            <span class="reg-title">{{ lang.rePassword }}</span> <input v-model="reg.rePassword" type="password" maxlength="20" :placeholder="lang.enter" />
            <label class="lab-error error-rePassword"></label>
          </li>
          <li><verify v-show="$route.query.type == undefined" @setVerifyCode="setVerifyCode" ref="verifyPc" /> <label class="lab-error error-verifyCode"></label></li>
          <li>
            <div class="reg-sub">
              <van-button size="large" type="danger" @click="goReg" :loading-text="lang.f_wait" :loading="isWait"> {{ lang.save }}</van-button>
            </div>
          </li>
        </ul>
      </div>

      <div class="reg-sub sub-wap">
        <!-- <div class="reg-agreement" v-html="lang.agreement">
        </div> -->
        <van-button size="large" type="danger" @click="goReg" :loading-text="lang.f_wait" :loading="isWait"> {{ lang.save }}</van-button>
      </div>
    </section>
  </div>
</template>

<script>
// import {
//   Button,
//   NavBar,
//   Field,
//   Cell,
//   CellGroup,
//   Popup,
//   Dialog
// } from "vant";
// import "vant/lib/button/style";
import lang from './../../common/language/register';
import guide from './../components/guide';
import navBar from './../components/navBar';
import navPc from './../components/navBar-pc';
import verify from './../components/verify-code';
export default {
  metaInfo() {
    return {
      title: '密碼找回'
    };
  },
  name: 'register',
  data() {
    return {
      type: 2,
      isWait: false,
      showAgentPop: false,
      lang: lang,
      cacheNum: '',
      email: '',
      showAction: false,
      actions: [],
      show: true,
      curSelect: '',
      // showCheckPop: false,
      errorText: '',

      reg: {
        email: '', //邮件
        phone: '', //电话
        password: '',
        rePassword: '',
        verifyCode: '',
        verifyToken: ''
      }
    };
  },
  created() {
    this.type = this.$route.query.type || 1;
    this.reg.email = this.$route.query.email || '';
    lang.phone = lang.telephone;
    if (this.type == 2) {
      lang.f_title = lang.resetPwd;
      lang.f_tip = lang.setPwd;
      //验证找回密码是否有效
      this.axios.get(this.pub.getApi().VerifyRetrievePasswordKey, { params: { key: this.$route.query.key } }).then(res => {
        res.data.code === 1315 && this.$router.push('/account/tips/?type=4');
      });
    }
  },
  methods: {
    //检测数字
    checkInt(field, type) {
      const num = this.reg[field];
      /^$|^\d+$/.test(num) ? (this.cacheNum = num) : (this.reg[field] = this.cacheNum);
      if (num && (num[0] == 0 || num[0] == 1)) this.reg[field] = num.replace(num[0], '');
    },

    //设置验证码
    setVerifyCode(verifyCode, verifyToken) {
      this.reg.verifyCode = verifyCode;
      this.reg.verifyToken = verifyToken;
    },

    goReg() {
      this.isWait = true;
      if (this.checkForm(document.body.clientWidth > 600 ? 'pc' : '', this.type)) {
        //发送找回密码请求
        if (this.type == 1) {
          this.axios.post(this.pub.getApi().RetrievePassword, this.reg, { params: { 'h-recaptchavalue': this.reg.verifyCode, 'h-recaptcha': this.reg.verifyToken } }).then(res => {
            this.isWait = false;
            this.reg.verifyCode = '';
            this.reg.verifyToken = '';
            if (res.data.code === 0) this.$router.push('/account/tips/?type=2');
            else if (res.data.code === 101) this.showError('verifyCode', lang.verifyCode + lang.inputError);
            else if (res.data.code === 103) this.showError('verifyCode', lang.verifyCode + lang.inputError);
            else if (res.data.code === 1321) this.showError('email', lang.f_accountError);
            else this.showError('email', lang.f_accountError);
            document.body.clientWidth < 600 ? this.$refs.verify.loadImg() : this.$refs.verifyPc.loadImg();
          });
        }
        //设置密码
        else if (this.type == 2) {
          this.reg.key = this.$route.query.key;
          this.axios.post(this.pub.getApi().resetPassword, this.reg).then(res => {
            this.isWait = false;
            if (res.data.code === 0) this.$router.push('/');
            else if (res.data.code === 1315) this.$router.push('/account/tips/?type=4');
          });
        }
      } else this.isWait = false;
      setTimeout(() => (this.isWait = false), 5000);
    },

    //验证所有文本框
    checkForm(device, type) {
      // console.log(type)
      const el = document.querySelectorAll('.lab-error');
      el.forEach(e => e.classList.remove('error-show'));
      let result = true;

      let regList = type == 2 ? ['password', 'rePassword'] : ['email', 'phone', 'verifyCode'];
      // console.log(type, type == 2, regList)
      //批量验证必填字段
      for (let i = 0; i < regList.length; i++) {
        if (typeof this.reg[regList[i]] === 'string' && !this.reg[regList[i]]) {
          this.showError(regList[i], `${this.lang.null}${this.lang[regList[i]]}`);
          regList[i] == 'phone' ? this.showError(regList[i], `${this.lang.null}${this.lang.linkPhone}`) : '';
          regList[i] == 'email' ? this.showError(regList[i], this.lang.emailNull) : '';
          regList[i] == 'rePassword' ? this.showError(regList[i], this.lang.confirmPassword) : '';
          //如果是pc端验证所有字段,wap端失败一项不再验证
          if (!device) return false;
          result = false;
        }
      }
      //验证邮箱格式
      if (type != 2) {
        (this.reg.email && !/^[a-zA-Z0-9]+([\.a-zA-Z0-9_-]*)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.reg.email)) || this.reg.email.indexOf('__') > -1
          ? (this.showError('email', `${this.lang.emailReg}`), (result = false))
          : '';
        this.reg.phone != '' && (this.reg.phone[0] == '0' || this.reg.phone[0] == '1') ? (this.showError('phone', `${this.lang.telError}`), (result = false)) : '';
      } else {
        this.reg.password !== this.reg.rePassword && this.reg.rePassword !== '' ? (this.showError('rePassword', this.lang.differentPassword), (result = false)) : '';
        this.reg.password && !/^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,20})$/.test(this.reg.password) ? (this.showError('password', `${this.lang.pwdError}`), (result = false)) : '';
        this.reg.password && this.reg.password.indexOf(' ') > -1 ? (this.showError('password', `${this.lang.password} ${this.lang.cantSpace}`), (result = false)) : '';
      }
      return result;
    },

    //显示错误信息
    showError(el, text) {
      // console.log(text)
      if (document.body.clientWidth > 600) {
        // console.log(el)
        const element = document.querySelector(`.error-${el}`);
        element.innerHTML = text;
        element.classList.add('error-show');
      } else {
        this.$notify(text);
      }
    }
  },
  components: {
    // [Button.name]: Button,
    // [NavBar.name]: NavBar,
    // [Field.name]: Field,
    // [Cell.name]: Cell,
    // [CellGroup.name]: CellGroup,
    // [Popup.name]: Popup,
    // [Dialog.name]: Dialog,
    guide,
    navBar,
    navPc,
    verify
  }
};
</script>

<style lang="scss">
.register {
  min-height: 100%;
  background-color: #f8f8f8;

  section {
    width: 100%;
  }
}

.reg-wap {
  width: 100%;
  margin-top: 30px;
  max-width: 500px;
  margin: auto;
}

// [class*='van-hairline']::after {
//   border-bottom: 0px !important;
// }

input,
textarea {
  padding-left: 10px;
  // margin-left: 10px;
}

button {
  cursor: pointer;
}

.flow-pc {
  text-align: left;
  letter-spacing: 1px;
  line-height: 30px;
  margin-top: 20px;
  font-size: 15px;

  .reg-pc-title {
    font-size: 25px;
    font-weight: 600;
    color: #ec404e;
    margin-bottom: 14px;
    display: block;
  }

  a {
    color: #3dbf6d;
    cursor: pointer;
  }
}

.lab-error {
  margin-left: 10px;
  color: #ed1c24;
  display: none;
}

.error-show {
  display: inline-block !important;
}

.forget-verify-code {
  padding-top: 1px;
  .custom-text {
    // margin: 5px 0;
  }
  input,
  img {
    margin: 5px 0;
  }
}
</style>
